import { Directive, input, InputSignal } from '@angular/core';

@Directive({ selector: '[uiProductTrackingList]' })
export class ProductTrackingListDirective {
  public readonly trackingList: InputSignal<string> = input.required<string>({ alias: 'uiProductTrackingList' });
}
